document.addEventListener("DOMContentLoaded", function () {
    // Parallax
    // const productbanner = new setParallax('.ingredients-detail__banner', '.ingredients-detail__banner-img');

});